import { render } from "./SottoprogettiCliente.vue?vue&type=template&id=cd4b8160&ts=true"
import script from "./SottoprogettiCliente.vue?vue&type=script&lang=ts"
export * from "./SottoprogettiCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__